import * as React from 'react';
import { cn } from '../../utils';

const colorMap = {
  pink: 'var(--riso-pink)',
  teal: 'var(--riso-teal)',
  amber: 'var(--riso-amber)',
  blue: 'var(--riso-blue)',
  cream: 'hsl(var(--background))',
} as const;

interface DecorativeSquareProps extends React.HTMLAttributes<HTMLDivElement> {
  width?: number;
  height?: number;
  color?: keyof typeof colorMap;
  rotate?: number;
}

const DecorativeSquare = React.forwardRef<
  HTMLDivElement,
  DecorativeSquareProps
>(
  (
    {
      width = 40,
      height = 40,
      color = 'pink',
      rotate,
      className,
      style,
      ...props
    },
    ref,
  ) => (
    <div
      ref={ref}
      aria-hidden
      className={cn('pointer-events-none rounded-md', className)}
      style={{
        width,
        height,
        backgroundColor: colorMap[color],
        ...(rotate !== undefined && { transform: `rotate(${rotate}deg)` }),
        ...style,
      }}
      {...props}
    />
  ),
);
DecorativeSquare.displayName = 'DecorativeSquare';

export { DecorativeSquare };
